import React from "react";

// components
import InfiniteMarquee from "../../../../../../components/InfiniteMarquee";

// interfaces
import { QuickSearchProps } from "./IQuickSearch";

// assets
import styles from "@/assets/styles/pages/lolive/quick-search.module.scss";

const QuickSearch = (
  { popularDestinations }: QuickSearchProps,
  ref?: React.Ref<HTMLElement>
) => {
  return (
    <section className={styles["locl-quick-search"]} data-testid="locl-quick-search" ref={ref}>
      <InfiniteMarquee
        items={(popularDestinations || []).map(({ href, label }) => (
          <a key={href} href={href}>
            {label}
          </a>
        ))}
      />
    </section>
  );
};

export default React.forwardRef(QuickSearch);
